var exports = {
  "kL": "xa9f3555f--143dd8--container",
  "DD": "xa9f3555f--143dd8--title",
  "_8": "xa9f3555f--143dd8--img",
};

module.exports = exports;
